import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-input-text',
  templateUrl: './modal-input-text.component.html',
  styleUrls: ['./modal-input-text.component.scss'],
})
export class ModalInputTextComponent {
  button_ok_title: string;
  question_title: string;
  value = new FormControl('');

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    this.button_ok_title = config.data!.button_ok_title;
    this.question_title = config.data!.question_title;
    if (config.data!.initial_value) {
      this.value.setValue(config.data!.initial_value);
    }
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({ value: this.value.value });
  }
}
